import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  CardActions,
  CardContent,
  Grid,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";

import ScalingContext from "../../../../../../context/scaling/ScalingContext";
import AuthContext from "../../../../../../context/auth/AuthContext";
import LayoutContext from "../../../../../../context/layout/LayoutContext";

import Action from "./Action/index";

import { UpdateScalingStatus } from "../../../controllers/useTodayReports";
import {
  CreateScalingActions,
  UpdateScalingActions,
} from "../../../controllers/useScalingActions";

export default function CardEdit(props) {
  const { cancelEdit } = props;

  const useStyles = makeStyles((theme) => ({
    cardAction: {
      borderTop: "1px solid",
      borderColor: theme.palette.action.selected,
      backgroundColor: theme.palette.action.hover,
      padding: "15px 20px",
    },
  }));
  const classes = useStyles();

  const { campaign_selected, scaling_status } = useContext(ScalingContext);
  const { user } = useContext(AuthContext);
  const { setAlert } = useContext(LayoutContext);

  const [scaling_actions, setScalingActions] = useState([]);

  const handleSubmit = async (e) => {
    // Function: Validate and Manage Scaling Status & Actions
    e.preventDefault();

    // Value Checking
    let filled = true;
    scaling_actions.forEach((action) => {
      if (action["actions"] === "") filled = false;
    });

    if (filled) {
      // With Existing Scaling Actions
      if (campaign_selected.actions.length > 0) {
        let old_actions = {};
        let to_update = [];

        // Set "Old" Scaling Actions into New Object - { ...[action_id]: data }
        old_actions = campaign_selected.actions.reduce(
          (prev_action, next_action) => ({
            ...prev_action,
            [next_action.action_id]: next_action,
          }),
          {} // initial value
        );

        // Compare New Value and Old Value
        scaling_actions.map((action) => {
          if (Object.keys(old_actions).includes(action.action_id)) {
            // Update Completed At Based On Status
            if (action.status === "PENDING") {
              action["completed_at"] = "";
            } else {
              action["completed_at"] = moment().format("YYYY-MM-DD HH:mm:ss");
            }

            // Compare New Value and Old Value
            const new_value = Object.values(action);
            const old_value = Object.values(old_actions[action.action_id]);

            const compared = new_value.filter(
              (val) => !old_value.includes(val)
            );
            const changes = compared.length !== 0;

            // Append Edited Action for Update
            if (changes) to_update.push(action);

            // Remove Matched Action From "Old" Scaling Actions
            delete old_actions[action.action_id];
          } else {
            // Append New Action for Creation
            to_update.push(action);
          }
        });

        // Convert "Old" Scaling Actions to An Array of Action ID for Deletion
        let to_delete = Object.keys(old_actions);

        // console.log("update scaling", to_delete, to_update);
        if (to_update.length > 0 || to_delete.length > 0) {
          UpdateScalingActions(setAlert, user.name, to_update, to_delete);
        }
      } else {
        // Without Existing Scaling Action
        // console.log("create scaling", scaling_actions);
        if (scaling_actions.length > 0) {
          CreateScalingActions(setAlert, user.name, scaling_actions);
        }
      }

      // Update Scaling Status
      // console.log("update campaign", scaling_status);
      if (scaling_status !== campaign_selected.scaling_status) {
        UpdateScalingStatus(
          setAlert,
          user.name,
          campaign_selected.campaign_id,
          scaling_status
        );
      }

      // Reset Selected Index, Campaign, Scaling Status
      cancelEdit();
    }
  };

  useEffect(() => {
    // Function: Duplicate Scaling Actions and Set State
    if (campaign_selected) {
      const new_array = [...campaign_selected.actions];
      setScalingActions(new_array);
    }
  }, [campaign_selected]);

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
      {" "}
      {/* Scaling Actions */}{" "}
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Action
              scaling_actions={scaling_actions}
              setScalingActions={setScalingActions}
            />{" "}
          </Grid>{" "}
        </Grid>{" "}
      </CardContent>
      {/* Button Actions */}{" "}
      <CardActions className={classes.cardAction}>
        <Grid container alignItems="center" justifyContent="flex-end">
          <Grid item>
            <Button variant="contained" onClick={() => cancelEdit()}>
              Cancel{" "}
            </Button>{" "}
            & emsp;{" "}
            <Button variant="contained" color="primary" type="submit">
              Save{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </CardActions>{" "}
    </Box>
  );
}
